import React, { useState, useEffect } from "react";
import { thisweekResult, lastweekResult } from "./leaderboardservice";
import socketService from "../services/socketService";
const LeaderboardContextTemplate = {
  lastWeekLeaderboard: {},
  currentWeekResult: {},
  topResult: [{}],
  getWeekResult: () => {},
  getRoundInfo: () => {},
  getWeekResultLW: () => {},
  getWeekResultAT: () => {},
  leaderboardWeekTab: "this",
  setLeaderboardWeekTab: () => {},
};

const LeaderboardContext = React.createContext(LeaderboardContextTemplate);

const LeaderboardProvider = ({ children }) => {
  const [lastWeekLeaderboard, setLastWeekLeaderboard] = useState({
    user_list: [],
    competition: {},
    pagination: {},
  });
  const [leaderboardWeekTab, setLeaderboardWeekTab] = useState("this");
  const [currentWeekResult, setCurrentWeekResult] = useState({});
  const [topResult, setTopResult] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [loadingTW, setLoadingTW] = useState(false);
  const [alreadyWon, setAlreadyWon] = useState(false);
  const [winners, setWinners] = useState([]);
  const [currentWeekEns, setCurrentWeekEns] = useState([]);
  const [lastWeekEns, setLastWeekEns] = useState([]);
  const [winnersEns, setWinnersEns] = useState([]);

  const [winnerLeaderboard, setWinnerLeaderboard] = useState(true);
  const [loserLeaderboard, setLoserLeaderboard] = useState(false);
  const [roundInfo, setRoundInfo] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [userlostamount, setUserLostAmount] = useState({
    totalRevenue: 0,
    iswinner: false,
  });

  const [winnerCount, setWinnerCount] = useState(0);

  useEffect(() => {
    getWeekResult();

    // Initialize socket connection
    socketService.connect();

    // Listen for leaderboard changes
    const handleLeaderboardChange = (data) => {
      console.log("Leaderboard change detected, refreshing data...");
      getWeekResultTW(1);
      getWeekResultLW(1);
    };

    socketService.on("leaderboardChange", handleLeaderboardChange);

    // Cleanup on unmount
    return () => {
      socketService.off("leaderboardChange", handleLeaderboardChange);
    };
  }, []);

  // Cleanup socket connection on component unmount
  useEffect(() => {
    return () => {
      socketService.disconnect();
    };
  }, []);

  const getWeekResult = async () => {
    //default page will be 1
    await getWeekResultTW(1);
  };

  const getWeekResultTW = async (page_number) => {
    try {
      setLoadingTW(true);
      const response = await thisweekResult({ page: page_number });

      // Handle new API response structure
      if (response.data.status) {
        setCurrentWeekResult({
          user_list: response.data.user_list || [],
          competition: response.data.competition || {},
          pagination: response.data.pagination || {},
        });
        setRoundInfo(response.data.competition || {});
        setWinnerCount(response.data.competition?.winnerCount || 0);
      } else {
        console.error("API returned status false:", response.data);
        setCurrentWeekResult({
          user_list: [],
          competition: {},
          pagination: {},
        });
      }
    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
      setCurrentWeekResult({ user_list: [], competition: {}, pagination: {} });
    } finally {
      setLoadingTW(false);
    }
  };
  const getWeekResultLW = async (page_number) => {
    try {
      const response = await lastweekResult({ page: page_number });

      if (response.data?.status) {
        setLastWeekLeaderboard({
          user_list: response.data.user_list || [],
          competition: response.data.competition || {},
          pagination: response.data.pagination || {},
        });
      } else {
        setLastWeekLeaderboard({
          user_list: [],
          competition: {},
          pagination: { currentPage: 1, totalPages: 1 },
        });
      }
    } catch (error) {
      console.error("Error fetching last-week leaderboard:", error);
      setLastWeekLeaderboard({
        user_list: [],
        competition: {},
        pagination: { currentPage: 1, totalPages: 1 },
      });
    }
  };

  const getWeekResultAT = async () => {
    console.warn("All-time leaderboard is not configured.");
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchInput(escapeRegExp(e.target.value.toLowerCase()));
  };

  const handleInputPaste = (e) => {
    const value = e.clipboardData.getData("Text");
    setSearchInput(value);
  };

  return (
    <LeaderboardContext.Provider
      value={{
        topResult,
        lastWeekLeaderboard,
        currentWeekResult,
        getWeekResult,
        getWeekResultTW,
        getWeekResultLW,
        getWeekResultAT,
        searchInput,
        setSearchInput,
        handleSearch,
        loadingTW,
        leaderboardWeekTab,
        setLeaderboardWeekTab,
        setAlreadyWon,
        alreadyWon,
        winners,
        handleInputPaste,
        showModal,
        setShowModal,
        winnersEns,
        currentWeekEns,
        lastWeekEns,
        winnerLeaderboard,
        setWinnerLeaderboard,
        loserLeaderboard,
        setLoserLeaderboard,
        userlostamount,
        setUserLostAmount,
        setCurrentWeekResult,
        roundInfo,

        winnerCount,
        setWinnerCount,
      }}
    >
      {children}
    </LeaderboardContext.Provider>
  );
};

export { LeaderboardContext };
export default LeaderboardProvider;
